import { Chip, ChipProps } from "@mui/material";

type UeCodeChipProps = { ueCode: string } & ChipProps;

const UeCodeChip: React.FC<UeCodeChipProps> = (props) => {
  const { ueCode, variant = "filled", size = "small", sx, ...chipProps } = props;

  return (
    <Chip
      variant={variant}
      size={size}
      label={ueCode}
      sx={{ borderRadius: 1, fontFamily: "monospace", mr: 1, ...sx }}
      {...chipProps}
    />
  );
};

export default UeCodeChip;
